"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIZARD_MESSAGE_TYPE_SINGLE_CHOICE = exports.WIZARD_MESSAGE_TYPE_RANGE = exports.WIZARD_MESSAGE_TYPE_PRODUCTS = exports.WIZARD_MESSAGE_TYPE_MULTIPLE_CHOICE = exports.WIZARD_MESSAGE_TYPE_INPUT = exports.WIZARD_MESSAGE_TYPE_GALLERY = void 0;
// LEGACY!!! PLEASE USE WizardPageTypes INSTEAD
const WIZARD_MESSAGE_TYPE_SINGLE_CHOICE = exports.WIZARD_MESSAGE_TYPE_SINGLE_CHOICE = 'single_choice';
const WIZARD_MESSAGE_TYPE_MULTIPLE_CHOICE = exports.WIZARD_MESSAGE_TYPE_MULTIPLE_CHOICE = 'multiple_choice';
const WIZARD_MESSAGE_TYPE_GALLERY = exports.WIZARD_MESSAGE_TYPE_GALLERY = 'gallery';
const WIZARD_MESSAGE_TYPE_RANGE = exports.WIZARD_MESSAGE_TYPE_RANGE = 'range';
const WIZARD_MESSAGE_TYPE_INPUT = exports.WIZARD_MESSAGE_TYPE_INPUT = 'input';
const WIZARD_MESSAGE_TYPE_PRODUCTS = exports.WIZARD_MESSAGE_TYPE_PRODUCTS = 'products';